import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { capitalize, formatDate, formatRelativeDate } from "@/lib/utils";

export function AbsoluteDate({ date }: { date: Date | string }) {
  const fullDate = formatDate(date);

  return (
    <Tooltip>
      <TooltipTrigger>{fullDate}</TooltipTrigger>
      <TooltipContent>{fullDate}</TooltipContent>
    </Tooltip>
  );
}

export function RelativeDate({
  date,
  capitalizeText = false,
}: {
  date: Date | string;
  capitalizeText?: boolean;
}) {
  let relative = formatRelativeDate(date);
  if (capitalizeText) relative = capitalize(relative);
  const fullDate = formatDate(date);

  return (
    <Tooltip>
      <TooltipTrigger>{relative}</TooltipTrigger>
      <TooltipContent>{fullDate}</TooltipContent>
    </Tooltip>
  );
}
